import { Component, OnInit, OnChanges, Input } from '@angular/core';

import { GlobalService } from '../../../../services/global.service';
import { ChatService } from '../../services/chat.service';

@Component({
  selector: 'app-other-user-profile',
  templateUrl: './other-user-profile.component.html',
  styleUrls: ['./other-user-profile.component.css', '../my-profile/my-profile.component.css']
})
export class OtherUserProfileComponent implements OnInit, OnChanges {

  @Input() thread: any;
  other_user_profile: any;
  file_list: any[] = [];

  last_file_key: any;

  constructor(
    public _globalService: GlobalService,
    public _chatService: ChatService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.thread) {
      this.getOtherUserDetail();
      this.getThreadFiles();
    }
  }

  getOtherUserDetail() {

    if (this._globalService.other_user_subscription) {
      this._globalService.other_user_subscription.unsubscribe();
    }

    const other_user_path = this._globalService.root_path + '/'
      + this._globalService.domain + '/users/' + this.thread.user_id;

    this._globalService.other_user_subscription =
      this._globalService._fireDB.object(other_user_path)
        .valueChanges()
        .subscribe((response: any) => {
          // console.log('other profile', response);

          this.other_user_profile = response;

        });

  }

  getThreadFiles() {

    const messages_path = this._globalService.root_path + '/' + this._globalService.domain
      + '/messages/' + this._globalService.selected_thread.thread_id;

    // this._globalService._fireDB.list(messages_path, ref =>
    //   ref.orderByKey().limitToLast(15)).valueChanges()
    //   .first()
    //   .subscribe(message => {
    //     console.log('filessssssssss ', message);
    //     this.file_list = message;
    //   });

    this._globalService._fireDB.list(messages_path, ref =>
      ref.orderByChild('type').equalTo(2).limitToLast(5)).snapshotChanges()
      .first()
      .subscribe((message: any) => {
        for (let i = 0 ; i < message.length ; i++) {
          this.file_list.push(message[i].payload.val());
        }
        if (!this.last_file_key && message.length) {
          this.last_file_key = message[message.length - 1].key;
        }
        // console.log('filessssssssss ', this.file_list);
      });

  }

  loadMoreFiles() {

    const messages_path = this._globalService.root_path + '/' + this._globalService.domain
    + '/messages/' + this._globalService.selected_thread.thread_id;

    // console.log(this.last_file_key, messages_path);
    if (this.last_file_key) {
      // this.chat_loader = true;
      this._globalService._fireDB.list(messages_path, ref =>
        ref.orderByKey().endAt(this.last_file_key).limitToLast(16))
        .snapshotChanges()
        .first()
        .subscribe(message => {
          // console.log('more message ', message);
          if (message.length) {
            this.last_file_key = message[0].key;
            for (let i = message.length - 2; i >= 0; i--) {
              this.file_list.unshift(message[i].payload.val());
            }
            if (message.length < 16) {
              // this.is_msg_paging_end = true;
            }
          }
          // this.chat_loader = false;
        },
        err => {
          // this.chat_loader = false;
        });
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/chat/sub-components/other-user-profile/other-user-profile.component.ts